module.exports = __webpack_public_path__ + "static/project3-31ce152f2ab26663d4541f878cb95892.jpg";